import { requestSiteMutation } from "./client";

export const claimApi = {
  // Claim an anonymous try-it site after signup. The anon_try_session
  // cookie (path=/api/try, SameSite=None;Secure) rides along on this
  // POST so the server can verify the session matches.
  claimAnonTry: (jobId: string) =>
    requestSiteMutation<{ siteId: string; subdomain: string }>("/api/try/claim", {
      method: "POST",
      body: JSON.stringify({ jobId }),
    }),
};
